// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "@charset \"UTF-8\";\n/* .content {\n  font-weight: bold;\n} */\n.v-list[data-v-52bf767d] {\n  background: #171921;\n  border: 1px solid #4A4A4A;\n}\n[data-v-52bf767d] .v-list-item__content {\n  color: white;\n}\n#urlText[data-v-52bf767d] {\n  background-color: white;\n  /* 하얀색 배경 설정 */\n  color: #535353;\n  width: 100%;\n  /* 부모 엘리먼트에 꽉 차게 설정 */\n  border: none;\n  padding: 8px;\n  box-sizing: border-box;\n  border-radius: 10px;\n}", ""]);
// Exports
module.exports = exports;
